import { AvailableGlobalPermissions, AvailablePermissionsValue, RequiredPermissions } from 'features/validateAccess';

export const getLocalMappingAccountPermissions = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.MAP,
    },
    {
      type: 'local',
      global: AvailableGlobalPermissions.ACCOUNT,
      local: accountId,
      value: AvailablePermissionsValue.MAP,
    },
  ],
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCESS_GROUP,
      value: AvailablePermissionsValue.READ,
    },
  ],
];

export const getArchiveAccountPermission = (accountId: string): RequiredPermissions => [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.ACCOUNT,
      value: AvailablePermissionsValue.ARCHIVE,
    },
    {
      type: 'local',
      global: AvailableGlobalPermissions.ACCOUNT,
      local: accountId,
      value: AvailablePermissionsValue.ARCHIVE,
    },
  ],
];
